<template>
  <div class="calculadora">
                  
    <v-row
    justify="center"
    >
      <v-col
      cols="12"
      sm="8"
      md="6"
      lg="4"
      >
        <v-card class="py-3 px-5" @keydown.enter="calcular">
          <v-form
          ref="form">
            <v-row
            justify="center"
            >
              <v-col
              cols="12"
              >
                <v-row align="center">
                  <v-col
                  cols="10"
                  >
                    <v-select
                    color="primary"
                    :items="items"
                    label="Tipo de negocio"
                    v-model="variables.tiponegocio"
                    :rules="negocioRules"
                    >
                    </v-select>
                  </v-col>
                  <v-col
                  cols="2"
                  >
                    <infopopup>
                      <template v-slot:infotitle>Tipo de negocio</template>
                      <template v-slot:infotext>Si escoge compraventa, hipoteca o cancelación de pagaré, la calculadora añadirá los correspondientes sellos de Asistencia Legal. Para otros negocios que no requieren dichos sellos, como las donaciones, escoja “Otros”.</template>
                    </infopopup>
                  </v-col>
                </v-row>

                <v-row align="center">
                  <v-col
                  cols="10"
                  >
                    <v-currency-field clearable 
                      color="primary"
                      label="Valor del negocio"
                      type="number"
                      prefix="$"
                      autocomplete="off"
                      v-model="variables.valornegocio"
                      :rules="valorRules"
                    />
                  </v-col>
                  <v-col
                  cols="2"
                  >
                    <infopopup>
                      <template v-slot:infotitle>Valor del negocio (base para el cómputo)</template>
                      <template v-slot:infotext>Este campo recoge el valor del negocio, que será la base para el cómputo de los aranceles notariales, derechos de inscripción y honorarios notariales.
                      <br><br>Para más información sobre la cancelación de aranceles en la obra notarial y la determinación de la base para el cómputo, recomendamos la lectura de la Instrucción General #15 de las Instrucciones Generales a los Notarios y Notarias publicadas por la Oficina de Inspección de Notarías (Revisadas – Julio 2016).
                      <br><br>Recuerde también que los aranceles notariales son gobernados por la Ley Núm. 101 de 12 de mayo de 1943, según enmendada, 4 LPRA sec. 851 et seq.; mientras que los derechos a pagarse en el Registro de la Propiedad para la inscripción de la escritura se rigen por la Ley de Aranceles del Registro de la Propiedad, Ley Núm. 91 de 30 de mayo de 1970, según enmendada.
                      </template>
                    </infopopup>
                  </v-col>
                </v-row>
<!--
                <v-expand-transition>
                  <v-row
                  align="center"
                  v-if="variables.tiponegocio === 'Hipoteca'"
                  >
                    <v-col
                    cols="10"
                    >
                      <v-checkbox
                      color="primary"
                      label="Crédito adicional de 10%"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                    cols="2"
                    >
                      <infopopup>
                        <template v-slot:infotitle>Créditos adicionales</template>
                        <template v-slot:infotext>Las Instrucciones Generales a los Notarios y Notarias publicadas por la Oficina de Inspección de Notarías (Revisadas – Julio 2016) nos indican lo siguiente:
                        <br><br>“Al computar la cuantía de los documentos a que se refiere la Ley Núm. 101, no se incluirán los créditos adicionales por intereses e intereses moratorios, ni los de costas y honorarios de abogado que se garanticen en el contrato. Sección 9 de la Ley Núm. 101, supra, 4 LPRA sec. 858. No obstante, los créditos adicionales para otros adelantos o gastos en las hipotecas no están expresamente excluidos de la ley, por lo que se toman en consideración al momento de determinar la cuantía del instrumento para el cómputo de los aranceles a cancelar. Director Of. Inspección Notarías v. Colón, 131 DPR 102, 120-121 (1992).”
                        </template>
                      </infopopup>
                    </v-col>
                  </v-row>
                </v-expand-transition>
-->
                <v-row>
                  <v-col
                  cols="12"
                  class="mt-2"
                  >
                  Porciento de honorarios
                  </v-col>
                  <v-col
                  cols="3"
                  class="text-right pr-0"
                  >
                    <span
                    class="text-h6 font-weight-light"
                    v-text="variables.porciento"
                    ></span>
                  </v-col>

                  <v-col
                  cols="1"
                  class="pl-0"
                  >
                    <span
                    class="text-h6 font-weight-light"
                    >%</span>
                  </v-col>

                  <v-col
                  cols="8"
                  >
                    <v-slider
                      v-model="variables.porciento"
                      aria-hidden="false"
                      aria-label="deslizador"
                      color="primary"
                      max="1"
                      min="0.5"
                      step="0.01"

                    >
                    
                      <template v-slot:prepend>
                        <v-icon
                          aria-hidden="false"
                          aria-label="disminuir"
                          color="primary"
                          @click="decrement"
                        >
                          mdi-minus
                        </v-icon>
                      </template>

                      <template v-slot:append>
                        <v-icon
                          aria-hidden="false"
                          aria-label="aumentar"
                          color="primary"
                          @click="increment"
                        >
                          mdi-plus
                        </v-icon>
                      </template>
                    </v-slider>
                  </v-col>

                </v-row>

                <v-checkbox
                color="primary"
                label="Aranceles Registro de la Propiedad"
                v-model="variables.aranceles"
                ></v-checkbox>

                <v-row
                align="center"
                >
                  <v-col
                  cols="7"
                  >
                    <v-checkbox
                    v-model="variables.estudiodetitulo"
                    color="primary"
                    label="Estudio de título"
                    ></v-checkbox>
                  </v-col>
                  <v-col
                  cols="5"
                  justify="left"
                  >
<!--                    <v-btn
                    outlined
                    :disabled="!variables.estudiodetitulo"
                    small
                    class="transition-color"
                    color="primary"
                    to="/resultados"
                    >
                      Solicitar
                    </v-btn>
-->
                  </v-col>
                </v-row>

              </v-col>
            </v-row>
          </v-form>

          <v-row col="12">
            <v-col
            col="6"
            >
              <v-btn
                tile
                block
                large
                color="grey darken-3"
                v-on:click="borrar"
              >
              Borrar
              </v-btn>
            </v-col>
            <v-col
            col="6"
            >
              <v-btn
                tile
                block
                large
                color="primary"
                v-on:click="calcular"
              >
              Calcular
              </v-btn>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
  .transition-color {
    transition: color 0.25s;
  }
</style>

<script>
import infopopup from '../components/infopopup'
export default {
  props: ['variables'],
  components: { infopopup },
  name: 'Home',
  data: () => ({
      items: ['Compraventa', 'Hipoteca', 'Cancelación de pagaré', 'Otros'],
      negocioRules: [
        v => !!v || 'Escoge un tipo de negocio',
      ],
      valorRules : [
        v => v.length >= 1 || 'Debe entrar una cantidad en números'
      ],
  }),
  methods: {
    decrement () {
      this.variables.porciento-=0.01
    },
    increment () {
      this.variables.porciento+=0.01
    },
    borrar () {
      this.$refs.form.reset()
    },
    calcular () {
      //validación
      if(this.$refs.form.validate()){
        //CÓMPUTO DE ARANCELES DE LA ESCRITURA
        //CÓMPUTO DE ARANCELES NOTARIALES
        //Cómputo en el caso especial de cancelaciones de hipotecas
        if(this.variables.tiponegocio === 'Cancelación de pagaré') {
          if(this.variables.valornegocio <= 5000000) {
            this.variables.honorariosnotariales = this.variables.valornegocio * (this.variables.porciento/100);
            this.variables.alerta = false;
            if(this.variables.honorariosnotariales < 250) {
              this.variables.honorariosnotariales = 250
            }
          }
          else if(this.variables.valornegocio > 5000000) {
            this.variables.honorariosnotariales = 250;
            this.variables.alerta = true
          }
        }
        //Cómputo cuando no son cancelaciones de hipotecas
        else {
          if(this.variables.valornegocio <= 10000) {
            this.variables.honorariosnotariales = 150
          }
          else if(this.variables.valornegocio <= 5000000) {
            this.variables.honorariosnotariales = this.variables.valornegocio * (this.variables.porciento/100);
            if(this.variables.honorariosnotariales < 250) {
              this.variables.honorariosnotariales = 250
            }
          }
          else if(this.variables.valornegocio > 5000000) {
            this.variables.honorariosnotariales = 5000000 * (this.variables.porciento/100);
            this.variables.alerta2 = true
          }
        }
        //CÓMPUTO DE SELLOS DE RENTAS INTERNAS
        if (this.variables.valornegocio < 250) {
          this.variables.rentasinternasoriginal = .5;
          this.variables.rentasinternascopia = .2;
        }
        else if (this.variables.valornegocio < 500) {
          this.variables.rentasinternasoriginal = 1;
          this.variables.rentasinternascopia = .5;
        }
        else if (this.variables.valornegocio < 1000) {
          this.variables.rentasinternasoriginal = 2;
          this.variables.rentasinternascopia = 1;
        }
        else if (this.variables.valornegocio < 5000) {
          this.variables.rentasinternasoriginal = 2 + (Math.ceil((this.variables.valornegocio - 1000) / 1000) * .5);
          this.variables.rentasinternascopia = 1 + (Math.ceil((this.variables.valornegocio - 1000) / 1000) * .2);
        }
        else {
          this.variables.rentasinternasoriginal = 2 + Math.ceil((this.variables.valornegocio - 1000) / 1000);
          this.variables.rentasinternascopia = 1 + (Math.ceil((this.variables.valornegocio - 1000) / 1000) * .5);
        }
        //CÓMPUTO DE SELLOS DE ASISTENCIA LEGAL
        if (this.variables.tiponegocio == 'Compraventa' ||
            this.variables.tiponegocio == 'Hipoteca' ||
            this.variables.tiponegocio == 'Cancelación de pagaré') {
          //Cómputo sellos Asistencia Legal en el original de la escritura
          if(this.variables.valornegocio < 25000) {
            this.variables.asistencialegaloriginal = 0;
          }
          else {
            this.variables.asistencialegaloriginal = Math.ceil(this.variables.valornegocio / 50000) * 5;
          }
          //Cómputo sellos Asistencia Legal en la copia certificada de la escritura
          this.variables.asistencialegalcopia = this.variables.asistencialegaloriginal / 2;
        }
        else {
          this.variables.asistencialegaloriginal = 0;
          this.variables.asistencialegalcopia = 0;
        }
        //CÓMPUTO DE ARANCELES DEL REGISTRO
        if(this.variables.aranceles) {
          if(this.variables.valornegocio <= 1000) {
            this.variables.comprobanteinscripcion = 2
          }
          else if(this.variables.valornegocio <= 25000) {
            this.variables.comprobanteinscripcion = Math.ceil(this.variables.valornegocio / 1000) * 2;
          }
          else {
            this.variables.comprobanteinscripcion = 50 + (Math.ceil((this.variables.valornegocio - 25000) / 1000) * 4);
          }
          this.variables.comprobantepresentacion = 15;
          this.variables.presentaciontelematica = 10;
          this.variables.rentasinternaspresentacion = 0.50;
        }
        else {
          this.variables.comprobantepresentacion = 0;
          this.variables.presentaciontelematica = 0;
          this.variables.comprobanteinscripcion = 0;
          this.variables.rentasinternaspresentacion = 0;
        }
        //ASIGNACIÓN DE COSTO DE ESTUDIO DE TÍTULO
        if (this.variables.estudiodetitulo) {
          this.variables.precioestudiodetitulo = 75
        }
        else {
          this.variables.precioestudiodetitulo = 0
        }
        //SUMA DE ARANCELES DE LA ESCRITURA
        this.variables.totalarancelesescritura =  this.variables.rentasinternasoriginal + this.variables.asistencialegaloriginal +
          this.variables.rentasinternascopia + this.variables.asistencialegalcopia + 1 + 1;
        //SUMA DE ARANCELES DEL REGISTRO DE LA PROPIEDAD
        this.variables.totalarancelesregistro = this.variables.comprobantepresentacion + this.variables.presentaciontelematica + this.variables.comprobanteinscripcion + this.variables.rentasinternaspresentacion;
        //SUMA DE HONORARIOS
        this.variables.totalhonorarios = this.variables.honorariosnotariales + this.variables.precioestudiodetitulo
        //SUMA DE COSTO TOTAL
        this.variables.costototal = this.variables.totalarancelesescritura + this.variables.totalarancelesregistro + this.variables.totalhonorarios;

        this.$router.push({ path: '/resultados' });
      }
    }
  },
}
</script>

<!--
Activar botón estudios de título
Terminar checkbox 10%
Para más adelante: Sin Cuantía = Diálogo o alerta
-->